import { VENSTER, t } from '../content/content'
import type { Video } from '../content/content'
import { useKiosk } from '../state/store'

/** Wat de onderdeelschermen delen: de veer van de podiumtransities en de filmknop. */
export const VEER = { duration: 0.7, ease: [0.16, 1, 0.3, 1] as const }

/** Het afspeelteken: een driehoek, optisch iets naar rechts zodat hij in een cirkel gecentreerd oogt. */
export function Afspeel() {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true">
      <path d="M9 6.5v11l9-5.5z" fill="currentColor" />
    </svg>
  )
}

/**
 * De knop naar de film van een keuze. Sinds de feedback van 21 oktober start
 * de film niet meer vanzelf: de bezoeker kiest zelf of hij hem bekijkt. Deze
 * knop is daarmee de enige weg naar de film en moet opvallen tussen de andere
 * actieknoppen — groter, met een rond wit afspeelteken, en één korte puls als
 * het paneel verschijnt (`.kiosk-film-knop` in app.css). Niet herhalend: een
 * knop die blijft knipperen leest als reclame.
 */
export function FilmKnop({ video }: { video: Video }) {
  const taal = useKiosk((s) => s.taal)
  const startVideo = useKiosk((s) => s.startVideo)
  return (
    <button className="kiosk-3d kiosk-film-knop" onClick={() => startVideo(video)}>
      <span className="kiosk-film-knop-rond" aria-hidden="true"><Afspeel /></span>
      {t(VENSTER.film, taal)}
    </button>
  )
}
